/**
 * Two-letter initials for avatars when no profile photo exists.
 * Prefers first + last word; falls back to email local-part or a single letter.
 */
export function personInitials(name, fallback = '') {
  const fromWords = initialsFromWords(name);
  if (fromWords) return fromWords;
  const raw = String(fallback || '').trim();
  if (raw.includes('@')) {
    const local = raw.split('@')[0].replace(/[._-]+/g, ' ');
    const fromEmail = initialsFromWords(local);
    if (fromEmail) return fromEmail;
    return local.slice(0, 2).toUpperCase() || '?';
  }
  const fromFallback = initialsFromWords(raw);
  if (fromFallback) return fromFallback;
  const compact = raw.replace(/[^A-Za-z0-9]/g, '');
  if (compact) return compact.slice(0, 2).toUpperCase();
  return '?';
}

function initialsFromWords(value) {
  const parts = String(value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  if (parts.length === 1) {
    const token = parts[0];
    if (token.length >= 2) return token.slice(0, 2).toUpperCase();
    return token[0].toUpperCase();
  }
  return '';
}

export function displayNameFromUserLike(user) {
  if (!user) return '';
  const first = String(user.firstName || '').trim();
  const last = String(user.lastName || '').trim();
  const full = `${first} ${last}`.trim();
  return full
    || String(user.name || user.displayName || user.username || user.who || '').trim();
}
